import { formatUIDate } from 'utils/helpers'
import { DailyRepoprtBETableItem } from '../interfaces'

const uniqueByName = (items: { name: string }[]) =>
  items.filter((item, index, self) => self.findIndex(i => i.name === item.name) === index)

export const toTableRowItems = (items: DailyRepoprtBETableItem[]) =>
  items.map(item => {
    const categoryDailyReports = item.wasteCategoryDailyReports || []

    return {
      id: item.id,
      reportNo: item.reportNo ?? '',
      storeName: item.storeName ?? '',
      creationDate: formatUIDate(item.creationDate),
      wasteCategories: uniqueByName(categoryDailyReports.map(r => ({ name: r.wasteCategoryName }))),
      wasteCompanies: uniqueByName(categoryDailyReports.map(r => ({ name: r.wasteCompanyName }))),
      isHandedOver: item.isHandedOver,
      documentNo: item.documentNo,
      isReportSigned: item.isReportSigned,
      reportUploadStatus: item.reportUploadStatus ?? null,
      isCompanyReport: item.isCompanyReport,
      showFlagIcon: item.reportUploadStatus === 'MANUAL_UPLOAD' && !item.isReportSigned
    }
  })
